module.exports = __webpack_public_path__ + "static/media/manufacturing-landscape.19575311.jpg";